/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Button, Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { DropdownMLStyled } from './DropdownMLStyled';

/**
 * 头部OK按钮
 * @param {*} param
 */
const DropdownML = ({
  // onClick,
  title,
  width = 'auto',
  height = 'auto',
  fontsize = '16px',
  menuClick,
  item,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  const handleMenuClick = (e) => {
    menuClick(e.key, item);
  };

  const onclick = (e) => {
    e.preventDefault();
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="2">设置为当前版本</Menu.Item>
      {/* <Menu.Item key="3">版本差异查看</Menu.Item> */}
    </Menu>
  );

  return (
    <DropdownMLStyled
      theme={themeContext}
      width={width}
      height={height}
      fontsize={fontsize}
      brand={brandContext}
    >
      <Dropdown overlay={menu} trigger={['click']}>
        <Button onClick={onclick}>
          {title}
          <DownOutlined />
        </Button>
      </Dropdown>
    </DropdownMLStyled>
  );
};

export default DropdownML;
